
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { PageLoading } from "@/components/shared/PageLoading";

// Lazy loaded pages
const TherapistPortal = lazy(() => import("@/pages/TherapistPortal"));
const TherapistAvailability = lazy(() => import("@/pages/portal/therapist/TherapistAvailability"));
const TherapistClients = lazy(() => import("@/pages/portal/therapist/TherapistClients"));
const TherapistMessaging = lazy(() => import("@/pages/portal/messaging/TherapistMessaging"));

const TherapistPortalRoutes = () => {
  return (
    <Routes>
      <Route path="/therapist-portal" element={
        <Suspense fallback={<PageLoading />}>
          <TherapistPortal />
        </Suspense>
      } />
      
      <Route path="/therapist-portal/availability" element={
        <Suspense fallback={<PageLoading />}>
          <TherapistAvailability />
        </Suspense>
      } />
      
      <Route path="/therapist-portal/clients" element={
        <Suspense fallback={<PageLoading />}>
          <TherapistClients />
        </Suspense>
      } />
      
      <Route path="/therapist-portal/messages" element={
        <Suspense fallback={<PageLoading />}>
          <TherapistMessaging />
        </Suspense>
      } />
    </Routes>
  );
};

export default TherapistPortalRoutes;
